import type { resolveExportTiming } from '../../../renderer/src/export-range';
import { filmTraversalBounds } from '../domain/camera-plan';

/** Full-film scrubbing uses the same source-clock rate as the selected export. */
export function previewClockSeconds(timing: ReturnType<typeof resolveExportTiming>): number {
  if (timing.sourceFrames < 2) return (timing.filmFrames - 1) / 30;
  return (timing.outputFrames - 1) / 30 * (timing.filmFrames - 1) / (timing.sourceFrames - 1);
}

/** Replay the selected film's approach using the same source marks as capture. */
export function openingPreviewBounds(timing: ReturnType<typeof resolveExportTiming>) {
  const first = timing.inFrame / (timing.filmFrames - 1);
  const span = (timing.outFrame - timing.inFrame) / (timing.filmFrames - 1);
  return { start: first, end: first + span * filmTraversalBounds(timing.durationSeconds).startSeconds / timing.durationSeconds };
}
